import React from "react";
import { DefaultHeader } from "../defaultHeader";
import { CustomHeader } from "../customHeader";

export default class HeaderTemplate extends React.Component {
  render() {
    return (
      <React.Fragment>
        {this.props.headerType === "default" ? (
          <div
            style={{
              position: "absolute",
              marginRight: "-1cm",
              marginLeft: "-1cm",
              top: "5px"
            }}
          >
            {this.props.petShop ? (
              <DefaultHeader
                style={{
                  width: "90%",
                  display: "block",
                  paddingTop: "5px",
                  paddingBottom: "15px"
                }}
                petShop={this.props.petShop}
                banner={this.props.banner}
              />
            ) : (
              ""
            )}
          </div>
        ) : (
          <CustomHeader header={this.props.banner} />
        )}   
      </React.Fragment>
    );
  }
}
